exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-editor__editable {\n  min-height: 200px;\n}\na.cke_button_off:hover,\na.cke_button_off:focus,\na.cke_button_off:active {\n  background: #e5e5e5;\n  border: 1px #bcbcbc solid;\n  padding: 2px 5px !important;\n}\na.cke_button_expandable.cke_button_off:hover,\na.cke_button_expandable.cke_button_off:focus,\na.cke_button_expandable.cke_button_off:active {\n  padding: 2px 2px !important;\n}\n.cke_toolgroup {\n  display: contents !important;\n}\n.cke_editable p,\n.cke_editable div {\n  margin: 0 !important;\n}\n", ""]);

// exports
